import { render, staticRenderFns } from "./DTabs.vue?vue&type=template&id=62202d5d&scoped=true&"
import script from "./DTabs.vue?vue&type=script&lang=js&"
export * from "./DTabs.vue?vue&type=script&lang=js&"
import style0 from "./DTabs.vue?vue&type=style&index=0&id=62202d5d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62202d5d",
  null
  
)

export default component.exports